import { FunctionComponent, PropsWithChildren } from 'react';

import { FormControl } from '@mui/material';

import BaseFormInputField from '../../../../../shared/components/base-input-form-field/base-form-input-field';
import { ExceptedAppsReleaseFormProps } from '../types/excepted-apps-release-form-props.type';

export const AndroidMaxSdkVersionInput: FunctionComponent<
  ExceptedAppsReleaseFormProps
> = (props: PropsWithChildren<ExceptedAppsReleaseFormProps>) => {
  const { values, errors, touched, handleChange, handleBlur } = props;

  return (
    <FormControl>
      <BaseFormInputField
        id="android-max-sdk-version"
        label="Android Max SDK Version"
        name="androidMaxSDKVersion"
        onBlur={handleBlur}
        onChange={handleChange}
        error={!!errors.androidMaxSDKVersion && touched.androidMaxSDKVersion}
        helperText={
          !!errors.androidMaxSDKVersion &&
          touched.androidMaxSDKVersion &&
          errors.androidMaxSDKVersion
        }
        value={values?.androidMaxSDKVersion ?? ''}
        InputLabelProps={{ required: true }}
      />
    </FormControl>
  );
};
